// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"5b9e80d5","100":"aa0b594f"}[chunkId] + ".chunk.js";
};